/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { financeRequirementsPostRequestSchema } from './financeRequirementsPostRequestSchema.ts';
import { financeRequirementsPostResponseSchema } from './financeRequirementsPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postFinanceRequirements200Schema = z.lazy(() => financeRequirementsPostResponseSchema);

/**
 * @description 505 response
 */
export const postFinanceRequirements505Schema = z.any();

export const postFinanceRequirementsMutationRequestSchema = z.lazy(() => financeRequirementsPostRequestSchema);

export const postFinanceRequirementsMutationResponseSchema = z.lazy(() => postFinanceRequirements200Schema);
